import { useIntl } from "react-intl";
import type { Control } from "react-hook-form";

import type { PostMeetingFormWithSummary } from "../form";
import { FIELD_LABELS } from "../messages";

import TextField from "./TextField";

export interface GoalsAndInterestsFieldProps {
  control: Control<PostMeetingFormWithSummary>;
}

export default function GoalsAndInterestsField({
  control,
}: GoalsAndInterestsFieldProps) {
  const { $t } = useIntl();

  return (
    <TextField
      name="goalsAndInterests"
      label={$t(FIELD_LABELS.goalsAndInterests)}
      control={control}
    />
  );
}
